const CancelOrder: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="30"
      height="30"
      fill="none"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        fill="currentColor"
        d="M3.75 3.75C3.06 3.75 2.5 4.31 2.5 5V22.5C2.5 24.5712 4.17875 26.25 6.25 26.25H13.2349C12.7649 25.0912 12.5 23.8275 12.5 22.5H8.75C8.06 22.5 7.5 21.94 7.5 21.25C7.5 20.56 8.06 20 8.75 20H12.8271C13.0559 19.1125 13.3989 18.2738 13.8477 17.5H8.75C8.06 17.5 7.5 16.94 7.5 16.25C7.5 15.56 8.06 15 8.75 15H15.9009C17.6621 13.4487 19.9688 12.5 22.5 12.5V5C22.5 4.31 21.94 3.75 21.25 3.75H3.75ZM8.75 7.5H16.25C16.94 7.5 17.5 8.06 17.5 8.75V10C17.5 10.69 16.94 11.25 16.25 11.25H8.75C8.06 11.25 7.5 10.69 7.5 10V8.75C7.5 8.06 8.06 7.5 8.75 7.5ZM26.25 8.75C25.56 8.75 25 9.31 25 10V12.8271C25.8875 13.0559 26.7262 13.3989 27.5 13.8477V10C27.5 9.31 26.94 8.75 26.25 8.75ZM22.5 15C18.3727 15 15 18.3727 15 22.5C15 26.6273 18.3727 30 22.5 30C26.6273 30 30 26.6273 30 22.5C30 18.3727 26.6273 15 22.5 15ZM22.5 17.5C23.4296 17.5 24.2863 17.7672 25.0293 18.2031L18.2031 25.0293C17.7672 24.2863 17.5 23.4296 17.5 22.5C17.5 19.7238 19.7238 17.5 22.5 17.5ZM26.7969 19.9707C27.2328 20.7137 27.5 21.5704 27.5 22.5C27.5 25.2762 25.2762 27.5 22.5 27.5C21.5704 27.5 20.7137 27.2328 19.9707 26.7969L26.7969 19.9707Z"
      />
    </svg>
  );
};

export default CancelOrder;
